import { Box } from "@chakra-ui/react";
import { Route, Routes } from "react-router";
import { Link } from "react-router-dom";
import AppLayout from "./layouts/AppLayout";
import StatsLayout from "./layouts/StatsLayout";
import PageCohort from "./routes/cohorts/components/PageCohort";
import PageCohorts from "./routes/cohorts/components/PageCohorts";
import PageEncrypt from "./routes/encrypt/PageEncrypt";
import PageExchange from "./routes/exchange/PageExchange"; 
import ExternalSearchPage from "./routes/exchange/ExternalSearchPage"; 
import PageIndividual from "./routes/individuals/components/PageIndividual";
import PageRegistries from "./routes/registries/components/PageRegistries";
import PageRegistry from "./routes/registries/components/PageRegistry";
import PageSettingsProfile from "./routes/settings/components/PageSettingsProfile";
import PageSettingsSupport from "./routes/settings/components/PageSettingsSupport";
import StatsDashboard from "./routes/stats/components/StatsDashboard";
import StatsWelcome from "./routes/stats/components/StatsWelcome";
import DataAccessRequestsPage from "./routes/exchange/DataAccessRequestsPage";
import PendingRequestsPage from "./routes/exchange/PendingRequestsPage";
import ApprovedRequests from "./routes/exchange/ApprovedRequest";
import ApprovedRequest from "./routes/exchange/ApprovedRequest";
import RejectedRequest from "./routes/exchange/RejectedRequest";
import ViewAllRequestsPage from "./routes/exchange/ViewAllRequestsPage";
import ExchangeApprovedRequest from "./routes/exchange/ExchangeApprovedRequest";

const AppAuthenticated = () => {
  return <AppRoutes />;
};

const AppStatsRoutes = () => {
  return (
    <StatsLayout>
      <Routes>
        <Route path="dashboard" element={<StatsDashboard />} />
        <Route path="*" element={<StatsWelcome />} />
      </Routes>
    </StatsLayout>
  );
};

const AppRoutes = () => {
  return (
    <AppLayout>
      <Box as={Routes} h="full" w="full">
        <Route path="/app/registries/:registryId" element={<PageRegistry />} />
        <Route
          path="/app/registries/:registryId/individual/:individualId"
          element={<PageIndividual />}
        />
        <Route path="/app/cohorts" element={<PageCohorts />} />
        <Route path="/app/encrypt" element={<PageEncrypt />} />
        <Route path="/app/cohorts/:cohortId" element={<PageCohort />} />
        <Route path="/app/settings/profile" element={<PageSettingsProfile />} />
        <Route path="/app/settings/support" element={<PageSettingsSupport />} />
        <Route path="/stats/*" element={<AppStatsRoutes />} />
        <Route path="*" element={<PageRegistries />} />
        <Route path="/app/exchange" element={<PageExchange />} />
        <Route path="/external-search" element={<ExternalSearchPage />} /> 
        <Route path="/data-access-requests" element={<DataAccessRequestsPage />} />
        <Route path="/pending-requests" element={<PendingRequestsPage />} /> 
        <Route path="/approved-request" element={<ApprovedRequest />} /> 
        <Route path="/rejected-request" element={<RejectedRequest />} /> 
        <Route path="/view_all_requests_page" element={<ViewAllRequestsPage />} /> 
        <Route path="/exchange_approved_request" element={<ExchangeApprovedRequest />} />
      </Box>
    </AppLayout>
  );
};

export default AppAuthenticated;
